import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SBIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SB" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#579D20"
          fillRule="evenodd"
          d="M0 12h16V0L0 12Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          d="m-.391 12.373-.902-1.248L16.837-.977 17.74.27-.39 12.373Z"
        />
        <Path
          fill="#F7FCFF"
          d="M2.795 1.918h.677l-.5.546.25.762L2.51 2.8l-.683.472.219-.81-.501-.517.678-.028.287-.8.286.8Zm2.829 0h.677l-.5.546.25.762-.713-.425-.683.472.218-.81-.5-.517.678-.028.287-.8.286.8Z"
        />
        <Path
          fill="#F7FCFF"
          d="M2.795 4.918h.677l-.5.546.25.762L2.51 5.8l-.683.472.219-.81-.501-.517.678-.028.287-.8.286.8Zm2.829 0h.677l-.5.546.25.762-.713-.425-.683.472.218-.81-.5-.517.678-.028.287-.8.286.8ZM4.292 3.372h.677l-.5.546.25.762-.713-.425-.682.473.218-.81-.501-.518.678-.028.287-.8.286.8Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
